import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SubmitInfoService = /** @class */ (function () {
    function SubmitInfoService(httpObj) {
        this.httpObj = httpObj;
    }
    SubmitInfoService.prototype.updateAwbInfo = function (oauthToken, uniqueIdForAwb, country, reasonCodeDetailArrayList, fileInput) {
        var requestUrl = environment.baseUrl + environment.docUploadContext + environment.SUBMIT_REASON_CODE;
        var bodyData = {
            'unique-id': uniqueIdForAwb,
            'country': country,
            'rc_info': reasonCodeDetailArrayList,
        };
        var formData = new FormData();
        for (var _i = 0, fileInput_1 = fileInput; _i < fileInput_1.length; _i++) {
            var f = fileInput_1[_i];
            formData.append('file', f);
        }
        formData.append('document', JSON.stringify(bodyData));
        return this.httpObj.post(requestUrl, formData, this.setOptions(oauthToken));
    };
    SubmitInfoService.prototype.processData = function (data) {
        var resStr = new String();
        resStr = data;
        return resStr;
    };
    SubmitInfoService.prototype.setOptions = function (oauthToken) {
        var oauthHeader = new HttpHeaders({
            'apikey': oauthToken
        });
        return { headers: oauthHeader };
    };
    SubmitInfoService.prototype.base64ToBlob = function (base64, mime) {
        mime = mime || '';
        var sliceSize = 1024;
        var byteChars = window.atob(base64);
        var byteArrays = [];
        for (var offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
            var slice = byteChars.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: mime });
    };
    SubmitInfoService.ngInjectableDef = i0.defineInjectable({ factory: function SubmitInfoService_Factory() { return new SubmitInfoService(i0.inject(i1.HttpClient)); }, token: SubmitInfoService, providedIn: "root" });
    return SubmitInfoService;
}());
export { SubmitInfoService };
